import * as React from 'react'
import { ProfileAddressInput } from '/~/components/account/Profile'

const ProfileAddressStatus = () => {
  return <ProfileAddressInput formFieldPrefix='addressFields' />
}

export default ProfileAddressStatus
